import type { RiskLevel } from '../../../vendors-v2/types';

interface VendorDetailRiskBadgeProps {
  risk: RiskLevel | null;
  showIcon?: boolean;
  showRiskLabel?: boolean;
}

const RISK_CONFIG = {
  High: {
    bgStyle: 'linear-gradient(0deg, rgba(211, 47, 47, 0.1), rgba(211, 47, 47, 0.1)), #FFFFFF',
    borderColor: '#FFD1D2',
    text: 'text-[#D32F2F]',
    iconColor: '#D32F2F',
    padding: 'py-[2px] pl-[8px] pr-[10px]',
  },
  Medium: {
    bgStyle: 'linear-gradient(0deg, rgba(245, 165, 36, 0.1), rgba(245, 165, 36, 0.1)), #FFFFFF',
    borderColor: 'rgba(245, 165, 36, 0.2)',
    text: 'text-[#F5A524]',
    iconColor: '#F5A524',
    padding: 'py-[2px] px-[10px]',
  },
  Low: {
    bgStyle: 'linear-gradient(0deg, rgba(23, 201, 100, 0.1), rgba(23, 201, 100, 0.1)), #FFFFFF',
    borderColor: 'rgba(23, 201, 100, 0.2)',
    text: 'text-[#17C964]',
    iconColor: '#17C964',
    padding: 'py-[2px] px-[10px]',
  },
} as const;

export function VendorDetailRiskBadge({ risk, showIcon = false, showRiskLabel = true }: VendorDetailRiskBadgeProps) {
  if (!risk) {
    return <span className="font-['Inter'] text-sm text-[#94A3B8]">—</span>;
  }

  const config = RISK_CONFIG[risk];

  return (
    <span
      className={`inline-flex items-center justify-center gap-1 rounded border ${config.padding}`}
      style={{ background: config.bgStyle, borderColor: config.borderColor }}
    >
      <span
        className={`font-['Inter'] font-medium text-xs leading-4 uppercase text-center ${config.text}`}
      >
        {risk}{showRiskLabel ? ' Risk' : ''}
      </span>
    </span>
  );
}
